module.exports = __webpack_public_path__ + "img/denmark-cardiovascular-diseases-female.adf21487.png";